module.exports = __webpack_public_path__ + "img/con_9.7ef5f3ec.svg";